export const ATTACHMENT_API = `v1/attachments`;